import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    title: {
        defaultMessage: 'Registry',
        id: 'iaso.registry.title',
    },
    selectSingle: {
        id: 'blsq.treeview.label.selectSingle',
        defaultMessage: 'Select an org unit',
    },
    selectMultiple: {
        id: 'blsq.treeview.label.selectMultiple',
        defaultMessage: 'Select org unit(s)',
    },
    clear: {
        id: 'blsq.treeview.search.options.label.clear',
        defaultMessage: 'Clear',
    },
    confirm: {
        id: 'blsq.treeview.search.confirm',
        defaultMessage: 'Confirm',
    },
    cancel: {
        id: 'blsq.treeview.search.cancel',
        defaultMessage: 'Cancel',
    },
    error: {
        id: 'blsq.treeview.error',
        defaultMessage: 'Please select an org unit',
    },
    search: {
        id: 'blsq.treeview.label.selectSingle',
        defaultMessage: 'Select an org unit',
    },
    selectedOrgUnit: {
        id: 'iaso.instance.selectedOrgUnit',
        defaultMessage: 'Selected Org unit',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    type: {
        defaultMessage: 'Type',
        id: 'iaso.entities.type',
    },
    seeRegistry: {
        id: 'iaso.registry.seeRegistry',
        defaultMessage: 'See registry',
    },
    submission: {
        id: 'iaso.instance.titleSingle',
        defaultMessage: 'Submission',
    },
    editOnEnketo: {
        id: 'iaso.instance.instanceEditAction',
        defaultMessage: 'Edit the answers in Enketo',
    },
    form: {
        id: 'iaso.instance.formShort',
        defaultMessage: 'Form',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
    editOrgUnit: {
        defaultMessage: 'Edit org unit',
        id: 'iaso.orgUnits.edit',
    },
    map: {
        defaultMessage: 'Map',
        id: 'iaso.label.map',
    },
    list: {
        defaultMessage: 'List',
        id: 'iaso.label.list',
    },
    withShape: {
        defaultMessage: 'With territory',
        id: 'iaso.registry.withShape',
    },
    withLocation: {
        defaultMessage: 'With point',
        id: 'iaso.registry.withLocation',
    },
    noGeographicalData: {
        defaultMessage: 'Without geography',
        id: 'iaso.label.noGeographicalData',
    },
    addOrgUnitChild: {
        defaultMessage: 'Add new child org unit',
        id: 'iaso.registry.addOrgUnitChild',
    },
    noInstance: {
        defaultMessage: 'No submission found for this org unit',
        id: 'iaso.registry.noInstance',
    },
    referenceInstance: {
        defaultMessage: 'reference submission',
        id: 'iaso.registry.referenceInstance',
    },
    showNames: {
        defaultMessage: 'Show names',
        id: 'iaso.registry.showNames',
    },
    source: {
        defaultMessage: 'Source',
        id: 'iaso.forms.source',
    },
    close: {
        id: 'iaso.label.close',
        defaultMessage: 'Close',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    deleteTitle: {
        id: 'iaso.instance.deleteTitle',
        defaultMessage: 'Are you sure you want to delete this submission?',
    },
    deleteText: {
        id: 'iaso.instance.deleteText',
        defaultMessage: 'Undelete is possible on submission detail page',
    },
    startPeriod: {
        id: 'iaso.instance.start',
        defaultMessage: 'Start period',
    },
    endPeriod: {
        id: 'iaso.instance.end',
        defaultMessage: 'End period',
    },
    periodError: {
        id: 'iaso.instance.chronologicalPeriodError',
        defaultMessage: 'Start period should be before end period',
    },
    missingSubmission: {
        id: 'iaso.registry.missingSubmission',
        defaultMessage: 'Missing submissions',
    },
    missingSubmissionCount: {
        id: 'iaso.registry.missingSubmissionCount',
        defaultMessage: '{count} org unit(s) without submission for this form',
    },
    createOnEnketo: {
        id: 'iaso.registry.createOnEnketo',
        defaultMessage: 'Create on Enketo',
    },
    add: {
        id: 'iaso.label.add',
        defaultMessage: 'Add',
    },
    periodType: {
        id: 'iaso.label.periodType',
        defaultMessage: 'Period type',
    },
    markerClustering: {
        id: 'iaso.map.title.markerClustering',
        defaultMessage: 'Clustering',
    }
});

export default MESSAGES;
